import "./style.scss";
import ArrowTipIcon from "./img/arrow-tip-right.svg?react";
import UpArrowIcon from "./img/chevron.svg?react";
import UpBlueArrowIcon from "./img/up-blue-arrow.svg?react";
import DownBlueArrowIcon from "./img/down-blue-arrow.svg?react";

const iconMap = new Map([
  ["up-arrow", UpArrowIcon],
  ["right-arrow-orange", ArrowTipIcon],
  ["up-arrow-blue", UpBlueArrowIcon],
  ["down-arrow-blue", DownBlueArrowIcon],
]);

export default function UnderlineButton({
  children,
  href,
  onClick,
  icon,
  target = "_self",
  className = ""
}) {
  const IconComponent = iconMap.get(icon);

  const isLink = href;
  return isLink ? (
    <div className={`underline-button ${className}`}>
      <a
        href={href}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
      >
        <div className="inner">
          <p>{children}</p>
          {icon && <IconComponent />}
        </div>
      </a>
    </div>
  ) : (
    <button onClick={onClick} className={`underline-button ${className}`}>
      <div className="inner">
        <p>{children}</p>
        {icon && <IconComponent />}
      </div>
    </button>
  );
}
